import './App.css';
import Hero from './Components/Hero';
import ProductPage from './Components/ProductPage';
import Sidebar from './Components/Sidebar';
import Slider from './Components/Slider';
import AllRoutes from './Routes/AllRoutes';
import Navbar from './Routes/Navbar';
import SinglePage from './pages/SinglePage';

function App() {
  return (
    <div >
     <Navbar/>
    <AllRoutes/>


    </div>
  );
}

export default App;
